<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner2.png">
        <div class="box-font">采购公告</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <!-- <div>
          <leftmenu :value='type' :list='purchase_menulist' @datashow=contentshow></leftmenu> -->
          <!--登录-->
          <!-- <leftlogin :formData.sync="form"></leftlogin>
        </div>         -->
        <div style="padding-top: 20px; margin-left: 20px;width:100%; border: 1px solid #CCCCCC;" v-if="Category > 0">
          <h3 style="text-align: center;">{{ detail.zbTitle }}</h3>
          <p style="text-align: center;font-size: 16px;">{{ detail.zbPublishTime }}</p>
          <tr>
            <td width="200" height="28" align="right"><span style="font-weight: bold">招标编号：</span></td>
            <td width="360" align="left" style="padding-left:10px">{{ detail.Subtitle }}</td>
          </tr>
          <tr>
            <td height="28" align="right"><span style="font-weight: bold">开标时间：</span></td>
            <td width="560" style="padding-left:10px">{{ detail.BeginTime }}</td>
          </tr>
          <tr>
            <td height="28" align="right"><span style="font-weight: bold">所属行业：</span></td>
            <td width="560" style="padding-left:10px">{{ detail.Word_Text }}</td>
          </tr>
          <tr>
            <td height="28" align="right"><span style="font-weight: bold">截止时间：</span></td>
            <td width="560" style="padding-left:10px">{{ detail.EndTime != "0001-01-01 00:00:00" ? detail.EndTime : ''
              }}</td>
          </tr>
          <div v-for="(dt, index) in details" :key="index" style="padding: 30px;">
            <h3 style="text-align: center;padding-top:30px;">{{ dt.Title }}</h3>
            <p style="text-align: center;font-size: 16px;">{{ dt.PublishTime }}</p>
            <div style="padding: 30px;" v-html= dt.Content></div>
          </div>
        </div>
        <div style="padding-top: 20px; margin-left: 20px;width:100%; border: 1px solid #CCCCCC;" v-else>
          <h3 style="text-align: center;">{{ detail.zbTitle }}</h3>
          <tr>
            <td width="200" height="28" align="right"><span style="font-weight: bold">发布招标时间：</span></td>
            <td width="360" align="left" style="padding-left:10px">{{ detail.PublishTime }}</td>
          </tr>
          <tr>
            <td width="180" height="28" align="right"><span style="font-weight: bold">招标编号：</span></td>
            <td width="360" align="left" style="padding-left:10px">{{ detail.Subtitle }}</td>
          </tr>
          <tr>
            <td height="28" align="right"><span style="font-weight: bold">开标时间：</span></td>
            <td width="560" style="padding-left:10px">{{ detail.BeginTime }}</td>
          </tr>
          <tr>
            <td height="28" align="right"><span style="font-weight: bold">所属行业：</span></td>
            <td width="560" style="padding-left:10px">{{ detail.Word_Text }}</td>
          </tr>
          <tr>
            <td height="28" align="right"><span style="font-weight: bold">截止时间：</span></td>
            <td width="560" style="padding-left:10px">{{ detail.EndTime != "0001-01-01 00:00:00" ? detail.EndTime : ''
              }}</td>
          </tr>
          <h3 style="text-align: center;padding-top:30px;">{{ detail.Title }}</h3>
          <p style="text-align: center;font-size: 16px;">{{ detail.PublishTime }}</p>
          <div style="padding: 30px;" v-html=detail.Content></div>
        </div>      
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "purchasedetail",
  components: { leftlogin, leftmenu },
  data() {
    return {
      detail: [],
      details: [],
      purchase_menulist: [],
      Id: 0,
      Category: 0,
      type: 0,
      form: {
        name: "",
        pass: "",
        type: ""
      }
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.Id = this.$route.query.id;
    this.Category = this.$route.query.Category;
    var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];
    this.purchase_menulist = menulist.filter(function (item) {
      return item.Word_Group_Key == 'IndustryType'
    });
    if (this.Category) {
      this.getData();
    } else {
      this.getData1();
    }
  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/Notice/Explain?id=" + that.Id + "&Category=" + that.Category, null, r => {        
        for(var i = 0; i<r.response.data.length; i++){          
          that.details.push(r.response.data[i])
        }
        that.detail = r.response.data[0];
      });
    },
    getData1() {
      var that = this;
      that.$api.get("/Notice/" + that.Id, null, r => {
        that.detail = r.response;
        that.Content = that.detail.Content;
      });
    },
    contentshow(item) {
      this.$router.replace("/purchasenotice?id=" + item.Word_Value);
      return false;
    }
  },
  watch: {
    $route(to) {
      this.getData();
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
</style>
